import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { BUSINESS_PHONE_FORMATTED } from "@/lib/constants";

export default function ReviewRedirect() {
    const [status, setStatus] = useState("checking"); // checking | missing
    useEffect(() => {
        http.get("/public/config").then(({ data }) => {
            if (data.google_review_url) {
                window.location.replace(data.google_review_url);
            } else {
                setStatus("missing");
            }
        }).catch(() => setStatus("missing"));
    }, []);

    if (status === "checking") {
        return (
            <div className="min-h-screen flex items-center justify-center text-slate-400" data-testid="review-redirect">
                Opening Google review…
            </div>
        );
    }
    return (
        <div className="min-h-screen flex items-center justify-center p-6" data-testid="review-missing">
            <div className="card-surface p-6 max-w-md text-center">
                <h1 className="text-xl font-bold text-white">Review link coming soon</h1>
                <p className="mt-2 text-sm text-slate-400">
                    Jeffrey hasn't connected a Google review page yet. In the meantime, you can
                    reach him directly at <a className="text-emerald-300" href="tel:7132052971">{BUSINESS_PHONE_FORMATTED}</a>.
                </p>
            </div>
        </div>
    );
}
